import apiClient from './apiClient';

export const getCreditPacks = () =>
  apiClient.get('/api/credits/packs').then((res) => res.data);

export const createCreditPackCheckout = (packSize) =>
  apiClient.post('/api/credits/checkout-session', { pack_size: packSize }).then((res) => res.data);
